module.exports = __webpack_public_path__ + "img/dummy_tennis_001.4842acf0.jpg";